<template lang="pug">
	img.logo(src="../assets/huko-logo.svg" @click="backHome")
</template>

<script>
export default {
	name : 'Logo',
	props: {
		clickEvent: {
			type   : Boolean,
			default: true
		}
	},
	methods: {
		backHome () {
			if (this.clickEvent) this.$router.push('/')
		}
	}
}
</script>
